import React   from 'react';
import values  from '../../../../../../values';
import Context from '../../../../../../context';

import { Components     } from './components';
import { useTranslation } from 'react-i18next';
import {
  BreadCrumb    ,
  Pagination    ,
  TableHeader   ,
  TableLoading  ,
  ResponsiveView,
} from '../../../../../../components';

import './index.scss';

type Props = { rqData: any; showModalData: any; };

const PendingParentTransactionScreen: React.FC<Props> = (props: Props): React.ReactElement => {

  // # =================================================================================================================
  // # --------------------------------------------- Start Validate Values ---------------------------------------------

  const {
    selectedPayment,
    requestApproveParentTransaction,
    setRequestApproveParentTransaction,
  } = React.useContext(Context.RejectedParentTransaction);
  const { t } = useTranslation();

  // # ---------------------------------------------- End Validate Values ----------------------------------------------
  // # =================================================================================================================

  // ? =================================================================================================================
  // ? ----------------------------------------------- Start Return View -----------------------------------------------

  return (
    <section id="transactions-screen">
      <ResponsiveView.Row className="table-options-wrapper">
        <ResponsiveView.Column extraLarge={3} large={5} medium={5} className="bread-crumb-wrapper">
          <BreadCrumb />
        </ResponsiveView.Column>
        <ResponsiveView.Column extraLarge={6} large={6} medium={7} className="search-and-filter-wrapper">
          <Components.TimeFilter />
        </ResponsiveView.Column>
      </ResponsiveView.Row>
      <ResponsiveView.Container>
        <div className="table-content-wrapper">
          <table>
            <TableHeader headers={values.tableHeaders.REJECTED_PARENT_TRANSACTION.map((item) => t(item))}/>
            {props.rqData?.status === "loading" ? (<TableLoading />) : (<Components.Body data={props.rqData} />)}
          </table>
        </div>
        <div style={{display: "flex", justifyContent: "center", marginTop: "2rem", gap: "1rem",}}>
          <div></div>
        </div>
      </ResponsiveView.Container>
      {props.rqData?.status === "success" &&
        props.rqData?.data?.result?.totalDocs > 10 && (
          <div className="pagination">
            <Pagination
              page={requestApproveParentTransaction?.page}
              totalPages={props.rqData?.data?.result?.totalPages}
              onPaginate={(page: number) =>
                setRequestApproveParentTransaction({
                  ...requestApproveParentTransaction,
                  page: page,
                })
              }
            />
          </div>
        )}
      <Components.ShowInfo data={props.rqData?.data?.result?.docs[selectedPayment]} />
    </section>
  );

  // ? ------------------------------------------------ End Return View ------------------------------------------------
  // ? =================================================================================================================

};

export default PendingParentTransactionScreen;
